import { defineMessages } from 'react-intl-next';

export default defineMessages({
    label: {
        defaultMessage: 'Suggested articles',
        description: 'label for related articles in request create form based on text in summary field',
        id: 'cv.request.create.form.kb.suggestions.label',
    },
});
